/**
 * @author       luis.orihuela@agileengine.com (Luis Orihuela)
 * @copyright    Copyright (c) 2020, Zumper
 */

import { EVENT_NAMES, PROP_NAMES, type Payload, track } from '@zcode/mixpanel'

import { getPreviousPage } from '../helpers/previousPageLocalStorage'

export const mixpanelNavClick =
  ({
    buttonClicked,
    section,
    pageName,
    sectionTarget,
    includePreviousPage,
  }: {
    buttonClicked?: string
    section?: string
    pageName: string
    sectionTarget?: string
    includePreviousPage?: boolean
  }) =>
  () => {
    const payload: Payload = {
      [PROP_NAMES.BUTTON_CLICKED]: buttonClicked,
      [PROP_NAMES.PAGE_NAME]: pageName,
      [PROP_NAMES.SECTION_TARGET]: sectionTarget,
      [PROP_NAMES.SECTION]: section,
    }
    if (includePreviousPage) {
      const previousPage = getPreviousPage()
      payload[PROP_NAMES.PREVIOUS_PAGE] = previousPage
    }
    track({
      event: EVENT_NAMES.CLICK,
      payload,
    })
  }
